/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaTargetInput } from './CriteriaTargetInput';
import {
    CriteriaTargetInputFromJSON,
    CriteriaTargetInputFromJSONTyped,
    CriteriaTargetInputToJSON,
} from './CriteriaTargetInput';

/**
 * 
 * @export
 * @interface CreateCriteriaTargetsRequest
 */
export interface CreateCriteriaTargetsRequest {
    /**
     * 
     * @type {CriteriaTargetInput}
     * @memberof CreateCriteriaTargetsRequest
     */
    criteria: CriteriaTargetInput;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCriteriaTargetsRequest
     */
    facility_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCriteriaTargetsRequest
     */
    facility_system_tags: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCriteriaTargetsRequest
     */
    facility_custom_tag_ids: Array<string>;
}

/**
 * Check if a given object implements the CreateCriteriaTargetsRequest interface.
 */
export function instanceOfCreateCriteriaTargetsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criteria" in value;
    isInstance = isInstance && "facility_ids" in value;
    isInstance = isInstance && "facility_system_tags" in value;
    isInstance = isInstance && "facility_custom_tag_ids" in value;

    return isInstance;
}

export function CreateCriteriaTargetsRequestFromJSON(json: any): CreateCriteriaTargetsRequest {
    return CreateCriteriaTargetsRequestFromJSONTyped(json, false);
}

export function CreateCriteriaTargetsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaTargetsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criteria': CriteriaTargetInputFromJSON(json['criteria']),
        'facility_ids': json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'],
    };
}

export function CreateCriteriaTargetsRequestToJSON(value?: CreateCriteriaTargetsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criteria': CriteriaTargetInputToJSON(value.criteria),
        'facility_ids': value.facility_ids,
        'facility_system_tags': value.facility_system_tags,
        'facility_custom_tag_ids': value.facility_custom_tag_ids,
    };
}

